import {css} from "@panda/css";

import {AdditionalAreaIcon, AreaIcon, CalendarCheckIcon, FloorsIcon, FloorUpIcon, KitchenIcon, RoomsIcon, WorldSideIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {areaFormat} from "@pg-mono/string-utils";

import {useConstructionEndDate} from "../../../property/hooks/useConstructionEndDate";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IValueLabel} from "../../../variables/types/IValueLabel";
import {
    getTinderMultiLeadAdditionalAreas,
    getTinderMultiLeadKitchen,
    getTinderMultiLeadQuarters,
    TINDER_MULTI_LEAD_EMPTY_VALUE
} from "./tinder_multi_lead_utils";

interface IProps {
    property: IPropertyDetail;
    variables: {
        property_additional_areas?: IValueLabel[];
        property_kitchen_type?: IValueLabel[];
        property_quarters?: IValueLabel[];
    } | null;
}

export function TinderMultiLeadParameterList({property, variables}: IProps) {
    const {calculateConstructionEndDate} = useConstructionEndDate();
    const items = [
        {icon: RoomsIcon, label: "Pokoje", value: `${property.rooms}`},
        {icon: AreaIcon, label: "Metraż", value: areaFormat(property.area, {precision: 2})},
        {
            icon: FloorUpIcon,
            label: "Piętro",
            value: property.floor === 0 ? "Parter" : property.floor ? `${property.floor}` : TINDER_MULTI_LEAD_EMPTY_VALUE
        },
        {
            icon: CalendarCheckIcon,
            label: "Termin oddania",
            value: calculateConstructionEndDate(property.construction_end_date, property.offer.construction_date_range) || TINDER_MULTI_LEAD_EMPTY_VALUE
        },
        {icon: FloorsIcon, label: "Kondygnacje", value: property.floors ? `${property.floors}` : TINDER_MULTI_LEAD_EMPTY_VALUE},
        {icon: WorldSideIcon, label: "Strona świata", value: getTinderMultiLeadQuarters(property, variables)},
        {icon: KitchenIcon, label: "Kuchnia", value: getTinderMultiLeadKitchen(property, variables)},
        {icon: AdditionalAreaIcon, label: "Powierzchnie dodatkowe", value: getTinderMultiLeadAdditionalAreas(property, variables)}
    ];

    return (
        <ul className={listStyle}>
            {items.map((item) => {
                const Icon = item.icon;

                return (
                    <li className={rowStyle} key={item.label}>
                        <span className={labelStyle}>
                            <Icon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-gray-800)" />
                            <Text variant="info_txt_1" color="var(--colors-gray-700)">
                                {item.label}
                            </Text>
                        </span>
                        <Text variant="body_copy_2" strong align="right" color="var(--colors-secondary)" className={valueStyle}>
                            {item.value}
                        </Text>
                    </li>
                );
            })}
        </ul>
    );
}

const listStyle = css({
    listStyle: "none",
    m: 0,
    p: 0
});

const rowStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    minHeight: 40,
    py: 1,
    borderBottom: "1px solid var(--colors-gray-200)",
    "&:last-of-type": {
        borderBottom: "none"
    }
});

const labelStyle = css({
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    flexShrink: 0,
    maxWidth: "100px"
});

const valueStyle = css({
    flex: 1,
    minWidth: 0
});
import {css} from "@panda/css";

import {AdditionalAreaIcon, AreaIcon, CalendarCheckIcon, FloorsIcon, FloorUpIcon, KitchenIcon, RoomsIcon, WorldSideIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {areaFormat} from "@pg-mono/string-utils";

import {useConstructionEndDate} from "../../../property/hooks/useConstructionEndDate";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IValueLabel} from "../../../variables/types/IValueLabel";
import {
    getTinderMultiLeadAdditionalAreas,
    getTinderMultiLeadKitchen,
    getTinderMultiLeadQuarters,
    TINDER_MULTI_LEAD_EMPTY_VALUE
} from "./tinder_multi_lead_utils";

interface IProps {
    property: IPropertyDetail;
    variables: {
        property_additional_areas?: IValueLabel[];
        property_kitchen_type?: IValueLabel[];
        property_quarters?: IValueLabel[];
    } | null;
}

export function TinderMultiLeadParameterList({property, variables}: IProps) {
    const {calculateConstructionEndDate} = useConstructionEndDate();
    const items = [
        {icon: RoomsIcon, label: "Pokoje", value: `${property.rooms}`},
        {icon: AreaIcon, label: "Metraż", value: areaFormat(property.area, {precision: 2})},
        {
            icon: FloorUpIcon,
            label: "Piętro",
            value: property.floor === 0 ? "Parter" : property.floor ? `${property.floor}` : TINDER_MULTI_LEAD_EMPTY_VALUE
        },
        {
            icon: CalendarCheckIcon,
            label: "Termin oddania",
            value: calculateConstructionEndDate(property.construction_end_date, property.offer.construction_date_range) || TINDER_MULTI_LEAD_EMPTY_VALUE
        },
        {icon: FloorsIcon, label: "Kondygnacje", value: property.floors ? `${property.floors}` : TINDER_MULTI_LEAD_EMPTY_VALUE},
        {icon: WorldSideIcon, label: "Strona świata", value: getTinderMultiLeadQuarters(property, variables)},
        {icon: KitchenIcon, label: "Kuchnia", value: getTinderMultiLeadKitchen(property, variables)},
        {icon: AdditionalAreaIcon, label: "Powierzchnie dodatkowe", value: getTinderMultiLeadAdditionalAreas(property, variables)}
    ];

    return (
        <ul className={listStyle}>
            {items.map((item) => {
                const Icon = item.icon;

                return (
                    <li className={rowStyle} key={item.label}>
                        <span className={labelStyle}>
                            <Icon size="2.4" wrapperSize="2.4" wrapperColor="transparent" fill="var(--colors-gray-800)" />
                            <Text variant="info_txt_1" color="var(--colors-gray-700)">
                                {item.label}
                            </Text>
                        </span>
                        <Text variant="body_copy_2" strong align="right" color="var(--colors-secondary)" className={valueStyle}>
                            {item.value}
                        </Text>
                    </li>
                );
            })}
        </ul>
    );
}

const listStyle = css({
    listStyle: "none",
    m: 0,
    p: 0
});

const rowStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    minHeight: 40,
    py: 1,
    borderBottom: "1px solid var(--colors-gray-200)",
    "&:last-of-type": {
        borderBottom: "none"
    }
});

const labelStyle = css({
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    flexShrink: 0,
    maxWidth: "100px"
});

const valueStyle = css({
    flex: 1,
    minWidth: 0
});
